// extracted by mini-css-extract-plugin
module.exports = {"list":"QuickStats_list__eszC6","item":"QuickStats_item__bFZVR","itemLabel":"QuickStats_itemLabel__3I_YF","itemValue":"QuickStats_itemValue__6jmOB"};